import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

document.body.style.margin = '0';
document.body.style.padding = '0';
document.body.style.background = '#0f1117';
document.body.style.fontFamily = "'Inter', sans-serif";
document.body.style.color = '#e2e8f0';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
